import React, {Children, useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import {genRanHex} from "../utils";
import {useSelector} from "react-redux";
import {Icon} from "../components";
import {Collapse} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";
import styled from "styled-components";

const MenuChevron = styled(FontAwesomeIcon)`
  float: right;
  transition: transform 0.2s linear;
  transform: rotate(${props => props.open ? '0deg' : '-90deg'});
`

export default function NavitemGroup({icon, text, ...props}) {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(false);
  const [node, setNode] = useState();

  let location = useLocation();
  const id = genRanHex()
  const navbarSmall = useSelector(state => state.layout.navbarSmall);

  useEffect(() => {
    const handleClickOutside = event => {
      if (node && !node.contains(event.target)) {
        (!active || navbarSmall) && setOpen(false)
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {// Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [node, active, open]);

  useEffect(() => {
    if (node) {
      const isActive = Array.from(node.querySelectorAll('.sub-menu-items a')).some((el) => el.className.match(/\bactive\b/))
      setActive(isActive)
    }
  }, [location, node]);

  useEffect(() => {
    !navbarSmall && setOpen(active)
  }, [active])

  const handleListClick = () => {
    navbarSmall && setOpen(false)
  }

  useEffect(() => {
    if (navbarSmall) {
      setOpen(false)
    } else {
      active && setOpen(true  )
    }
  }, [navbarSmall])

  if( Children.toArray(props.children).length == 0 ) { return(<></>) }

  return (
    <li className="panel" ref={setNode}>
      <a
        className={active ? 'active' : ''}
        onClick={() => {
          setOpen(!open)
        }}
        aria-controls={id}
        aria-expanded={open}>
        <Icon icon={icon} text={text} />
        { !navbarSmall && <MenuChevron icon={faChevronDown} open={open}/> }
      </a>

      <Collapse in={open}>
        <ul className="list-unstyled sub-menu-items" id={id} onClick={handleListClick}>
          {props.children}
        </ul>
      </Collapse>
    </li>
  );
}
